export default __webpack_public_path__ + "static/step_collect-43bc5017f6f7e097e3fdd462ebcbedf7.webp";